import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.refund-advance-payment': {
         form: {
            fields: {
               refundAmount: {
                  label: 'Kwota zwrotu',
                  validate: {
                     cannotBeGreaterThanAdvancePaymentAmount: 'Kwota zwrotu nie może być wyższa niż kwota przedpłaty.',
                  },
               },
            },
            textView: {
               advancePaymentAmount: {
                  label: 'Przedpłata:',
               },
               afterRefundAmount: {
                  emptyPlaceholder: '- zł',
                  label: 'Do zapłaty po zwrocie:',
               },
               overpaymentAmount: {
                  label: 'Nadpłata:',
               },
               remainingAmount: {
                  label: 'Pozostało do zapłaty:',
               },
               totalAmount: {
                  label: 'Koszt wizyty:',
               },
            },
         },
         modal: {
            actions: {
               confirm: {
                  failureMessage: 'Nie udało się zlecić zwrotu przedpłaty. Spróbuj ponownie później',
                  label: 'Zwróć',
                  pendingMessage: 'Trwa przetwarzanie zwrotu',
                  successMessage: 'Zlecenie zwrotu przedpłaty zostało przekazane do realizacji w PayU',
               },
            },
            notificationContent:
               'Zwrot przedpłaty nastąpi za pośrednictwem PayU. Maksymalny czas realizacji zwrotu to 14 dni roboczych.',
            title: 'Zwrot przedpłaty',
         },
      },
   },
};

const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.shared.refund-advance-payment');

export const refundAdvancePaymentTranslationKeys = translationKeys;
